export const QUALIFICATION_ITEMS = {
  artesanatos: {
    key: 'artesanatos',
    label: 'artesanatos',
  },
  bolsas_e_mochilas: {
    key: 'bolsas_e_mochilas',
    label: 'bolsas e mochilas',
  },
  alimentos_pereciveis: {
    key: 'alimentos_pereciveis',
    label: 'alimentos perecíveis',
  },
  bebidas: {
    key: 'bebidas',
    label: 'bebidas',
  },
};

export const optionsItems = [
  { acessorios_fashion: 'Acessórios Fashion' },
  { acessorios_automotivos: 'Acessórios Automotivos' },
  { alimentos_industrializados: 'Alimentos Industrializados' },
  { alimentos_pereciveis: 'Alimentos Perecíveis' },
  { artesanatos: 'Artesanatos' },
  { bebidas: 'Bebidas' },
  { bolsas_e_mochilas: 'Bolsas e Mochilas' },
  { brinquedos_e_games: 'Brinquedos e Games' },
  { calcados: 'Calçados' },
  { casa_e_decoracao: 'Casa e Decoração' },
  { construcao_e_ferramentas: 'Construção e Ferramentas' },
  { cosmeticos_e_perfumaria_saude: 'Cosméticos e Perfumaria/Saúde' },
  { eletronicos: 'Eletrônicos' },
  { eletroportateis: 'Eletroportáteis' },
  { esporte_e_lazer: 'Esporte e Lazer' },
  { festas: 'Festas' },
  { flores_e_plantas: 'Flores e Plantas' },
  { informatica: 'Informática' },
  { instrumento_musical: 'Instrumento Musical' },
  { insumos: 'Insumos' },
  { joia_e_bijuteria: 'Joia e Bijuteria' },
  { livros: 'Livros' },
  { marketing_multinivel: 'Marketing Multinível' },
  { moveis_para_casa: 'Móveis para casa' },
  { moveis_para_escritorio: 'Móveis para escritório' },
  { oculos: 'Óculos' },
  { papelaria: 'Papelaria' },
  { pet_shop: 'Pet Shop' },
  { presentes: 'Presentes' },
  { religioso: 'Religioso' },
  { relogios: 'Relógios' },
  { roupas: 'Roupas' },
  { servicos: 'Serviços' },
  { sex_shop: 'Sex Shop' },
  { suplementos: 'Suplementos' },
  { telefonia_celulares: 'Telefonia/Celulares' },
  { outros: 'Outros' },
  { sem_empresa_formalizada: 'Sem empresa formalizada' },
];

export const QUALIFIED_ITEMS = 'qualified-items';
export const UNQUALIFIED_ITEMS = 'unqualified-items';
